<!-- <app-product-image [image]="preloginProduct.info.imageDTO"></app-product-image> -->

<section class="registration-product-information">
	<div class="registration-product-information__image-block">
		<div class="registration-product-information__image-wrapper">
			<app-product-image
				class="product-list-item__image"
				[image]="preloginProduct.registerScreenInfo.image"
				[productImageParams]="{ size: CARD_PICTURE.DESKTOP }"
			></app-product-image>
		</div>
	</div>

	<div class="registration-product-information__info-block">
		<p class="registration-product-information__info">{{ preloginProduct.name }}</p>

		<p class="registration-product-information__info">
			{{ preloginProduct.registerScreenInfo.name }}
		</p>

		<ul class="list">
			@for (profit of preloginProduct.registerScreenInfo.profits; track profit) {
				<li class="list__item">{{ profit }}</li>
			}
		</ul>
	</div>
</section>
